'use strict';

var IpnsPubsubDatastore = require('../../../ipns/routing/pubsub-datastore');

var errcode = require('err-code'); // Get pubsub from IPNS routing


exports.getPubsubRouting = function (ipns, options) {
  if (!ipns || !(options.EXPERIMENTAL && options.EXPERIMENTAL.ipnsPubsub)) {
    throw errcode(new Error('IPNS pubsub subsystem is not enabled'), 'ERR_IPNS_PUBSUB_NOT_ENABLED');
  } // Only one store and it is pubsub


  if (IpnsPubsubDatastore.isIpnsPubsubDatastore(ipns.routing)) {
    return ipns.routing;
  } // Find in tiered


  var pubsub = (ipns.routing.stores || []).find(function (s) {
    return IpnsPubsubDatastore.isIpnsPubsubDatastore(s);
  });

  if (!pubsub) {
    throw errcode(new Error('IPNS pubsub datastore not found'), 'ERR_PUBSUB_DATASTORE_NOT_FOUND');
  }

  return pubsub;
};